//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as b from '@/static/blog.json'

let blog = b.default

export default {
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.inicializarPorCategoria(to)
		})
	},
	beforeRouteUpdate(to, from, next) {
		this.inicializarPorCategoria(to)
		next()
	},

	data() {
		return {
			categoria: '',
			blogs: [],
		}
	},
	methods: {
		inicializarPorCategoria(to) {
			this.categoria = to.params.slug
			this.blogs = []
			this.blogs = blog.filter((a) =>
				// !a.categoria.find((c) => c.slug === 'noticia') &&
				a.categoria.find((c) => c.slug === this.categoria)
			)
		},
	},

	computed: {
		categoriasBlog() {
			let blogs = blog
			// .filter(
			//   (a) => !a.categoria.find((c) => c.slug === 'noticia')
			// )
			let categorias = blogs.map((n) => n.categoria).flat()
			let flated = [...new Set(categorias.map((c) => c.nome))]
			let final = []
			flated.forEach((element) => {
				categorias.find((c) => {
					if (
						c.nome === element &&
						!final.map((m) => m.nome).includes(element)
					) {
						final.push(c)
					}
				})
			})
			return final
		},
	},
}
